<template>
    <v-dialog v-model="isOpen" width="850" persistent>
      <template v-slot:activator="{ on }">
        <v-text-field
          v-on="on"
          hide-details
          readonly
          v-model="getProductString"
          :label="$t('lang_LABEL_STATISTICS_PRODUCTS')"
          :loading="loading"
          alvqa="label-statistics-textfield-product"
        ></v-text-field>
      </template>
      <v-card min-height="300" max-height="400" color="dialogStandardBackground">
        <v-toolbar color="dialogStandardHeaderBackground">
          <v-toolbar-title
            :alvqa="alvqa + '-title'"
            class="dialogStandardHeadlineText--text"
            >{{ $t("lang_LABEL_STATISTICS_PRODUCTS") }}</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-toolbar-items class="mt-4">
            <BaseIcon
              icon="close"
              color="iconCancel"
              @click="close"
              :alvqa="alvqa + '-icon-close'"
            ></BaseIcon>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-row class="ml-n5 mt-2">
            <v-col cols="6" class="mt-4">
              <v-chip
                v-for="(item, index) in [0, 1]"
                :key="index"
                @click="updateSearchType(item)"
                :color="
                  item === selectedSearchType ? 'selectedChip' : 'standard'
                "
                class="ml-2 pl-4 pr-4"
              >
                <div v-if="item === 0">
                  {{
                    $t(
                      "lang_ERP_INVOICES_CAPTION_INVOICEROWS_DIALOG_SEARCH_TRACKS"
                    )
                  }}
                </div>
                <div v-if="item === 1">
                  {{
                    $t(
                      "lang_ERP_INVOICES_CAPTION_INVOICEROWS_DIALOG_SEARCH_LABEL_RELEASES"
                    )
                  }}
                </div>
              </v-chip>
            </v-col>
            <v-col offset="2" cols="4">
              <DropdownFilter 
                    :context="context + 'SearchMode'"
                    field="SearchMode"
                    :hideErrorMessage="true"
                    :items="searchModes"
                    :alvqa="alvqa + '-list-dropdown-search-mode'"
                    :multiple="false"
                    :withMargin="false"
                    rules="required"
                    :clearable="false"
                    :additionalFunction="updateSearchMode"
                />
            </v-col>
          </v-row>
          <v-row class="mt-2" v-if="selectedSearchMode === 0">
            <v-col cols="12" v-if="selectedSearchType === 0">
              <BaseEditPageAutocomplete
                    :context="context"
                    field="Track"
                    :label="$t('lang_ERP_INVOICES_CAPTION_INVOICEROWS_DIALOG_SEARCH_TRACKS')"
                    :withMargin="false"
                    :multiple="false"
                    :withFreeText="false"
                    :isLoading="true"
                    :returnObject="false"
                    rules=""
                    :alvqa="alvqa+'-dropdown-track'"
                >
                    <template v-slot:selection = "{ item }">
                        {{ trackToText(item.value) }}
                    </template>
                    <template v-slot:items="{ items }">
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ trackToText(items.value) }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </template>
                </BaseEditPageAutocomplete>
            </v-col>
            <v-col cols="12" v-if="selectedSearchType === 1">
              <BaseEditPageAutocomplete
                    :context="context"
                    field="Release"
                    :label="$t('lang_ERP_INVOICES_CAPTION_INVOICEROWS_DIALOG_SEARCH_LABEL_RELEASES')"
                    :withMargin="false"
                    :multiple="false"
                    :withFreeText="false"
                    :isLoading="true"
                    :returnObject="false"
                    rules=""
                    :alvqa="alvqa+'-dropdown-release'"
                >
                    <template v-slot:selection = "{ item }">
                        {{ releaseToText(item.value) }}
                    </template>
                    <template v-slot:items="{ items }">
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ releaseToText(items.value) }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </template>
                </BaseEditPageAutocomplete>
            </v-col>
          </v-row>

          <v-row class="mt-2" v-if="selectedSearchMode === 1" >
            <v-col cols="11">             
              <BaseEditPageTextField 
                :context="context"
                field="Tags"
                :label="$t('lang_LABEL_TRACKS_CAPTION_TAGS')"
                :withMargin="false"
                :clearable="true"
                :additionalFunction="resetSearchByTags"
                :loading="loading"
                :alvqa="alvqa + '-textfield-tags'"
              />
            </v-col>
            <v-col cols="1" class="pt-7">             
              <BaseIcon 
                :alvqa="alvqa + '-list-icon-search'"
                icon="fa-search" 
                tooltipText="lang_GENERAL_CAPTION_START_SEARCH" 
                :disabled="disabledSearchByTags"
                @click="getProductsByTags"
              />
            </v-col>
            <v-col cols="12" v-if="getTagsSearchMessage" class="mt-n6">
              <span v-text="getTagsSearchMessage"></span>
            </v-col>
            
          </v-row>

          <v-row class="mt-2" v-if="selectedSearchMode === 2" >
            <v-col cols="12">             
              <v-autocomplete
                v-model="selectedLabel"
                :items="labelOptions"
                :label="$t('lang_LABEL')"
                item-text="text"
                item-value="value"
                :loading="loading"
                :clearable="true"
                hide-details
                @change="getProductsByLabel"
                :alvqa="alvqa + '-dropdown-label'"
              />
            </v-col>
            <v-col cols="12" v-if="getLabelSearchMessage" class="mt-n2">
              <span v-text="getLabelSearchMessage"></span>
            </v-col>
          </v-row>
        </v-card-text>
  
        <v-card-actions>
          <v-spacer />
          <v-btn
            :disabled="selectedProduct === null"
            @click="changedProduct"
            color="buttonStandard"
            class="white--text"
          >
            {{ $t("lang_BUTTON_SAVE") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
  <script>
  import BaseIcon from "@/components/_buttons/BaseIcon.vue";
  import BaseEditPageAutocomplete from '@/components/_editForm/BaseEditPageAutocomplete'
  import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'
  import DropdownFilter from '@/components/_filters/DropdownFilter'
  
  export default {
    name: "ProductDialog",
    props: ["value", "context"],
    components: { 
      BaseIcon, 
      BaseEditPageAutocomplete,
      BaseEditPageTextField,
      DropdownFilter
    },
    data() {
      return {
        isOpen: false,
        alvqa: "ChooseProductDialog",
        selectedRelease: null,
        tagsSearchMessage: null
      };
    },
    computed: {
      selectedSearchMode(){
        return this.$store.getters.getSelectedLabelStatisticsSearchMode
      },
      selectedSearchType(){
        return this.$store.getters.getSelectedLabelStatisticsSearchType 
      },
      selectedProduct(){
        return this.$store.getters.getLabelStatisticsDetailsProduct 
      },
      getProductString() {
        
        if (!this.selectedProduct) {
          return null;
        }

        if(this.selectedSearchMode === 0){
          if (this.selectedSearchType === 0) {
            return this.trackToText(this.selectedProduct);
          }
          if (this.selectedSearchType === 1) {
            return this.releaseToText(this.selectedProduct);
          }
        }
       
        if(this.selectedSearchMode === 1){
          if(this.selectedProduct.length === 0 ){
            return null
          }

          return this.getTagsSearchMessage
        }

        if(this.selectedSearchMode === 2){
          if(this.selectedProduct.length === 0 ){
            return null
          }

          return this.getLabelSearchMessage
        }

        return ''

      },
      selectedTags(){
          return this.$store.getters.getLabelStatisticsDetailsTags
      },
      searchModes(){
        return [
          { value: 0, text: this.$t('lang_GENERIC_CAPTION_PRODUCT_SEARCH'), alvqa: this.alvqa + '-list-dropdown-search-mode-product' },
          { value: 1, text: this.$t('lang_GENERIC_CAPTION_TAGS_SEARCH'), alvqa: this.alvqa + '-list-dropdown-search-mode-tags' },
          { value: 2, text: this.$t('lang_LABEL_STATISTICS_CAPTION_LABEL_SEARCH'), alvqa: this.alvqa + '-list-dropdown-search-mode-label' }
        ]
      },
      labelOptions(){
        return this.$store.getters.getLabelStatisticsLabelDropdownOptions
      },
      selectedLabel:{
        get() { return this.$store.getters.getLabelStatisticsSelectedLabel },
        set(value) { this.$store.commit('setLabelStatisticsSelectedLabel', value) }
      },
      disabledSearchByTags(){
        if(this.$store.getters.getLabelStatisticsDetailsTags && !this.loading) { return false }
        return true;
      },
      getTagsSearchMessage(){
        let message = this.$store.getters.getLabelStatisticsTagsSearchMessage;

        if(message === null){
          return null
        }

        if(message.num === 0){
          return this.$t(message.msg)
        }

        if(message.num > 0){
          return this.$t(message.msg, {number: message.num})
        }
        
        return null;
      },
      getLabelSearchMessage(){
        let message = this.$store.getters.getLabelStatisticsLabelSearchMessage;

        if(message === null){
          return null
        }

        if(message.num === 0){
          return this.$t(message.msg)
        }

        if(message.num > 0){
          return this.$t(message.msg, {number: message.num})
        }
        
        return null;
      },
      loading: {
            get() { return this.$store.getters.getIsLoading },
            set(value) { this.$store.commit('setIsLoading', value) }
      }
    },
    methods: {
      releaseToText(entry) {
        const text =
            entry.name +
            " (" +
            (entry.catalogueNumber !== null
              ? entry.catalogueNumber
              : entry.ean !== null
              ? entry.ean
              : entry.alvId) +
            ")";
        return text
      },
      trackToText(entry) {
        const text = `${entry.title} (${entry.isrc})`;
        return text;
      },
      changedProduct() {
        if(this.selectedSearchMode === 0){
          this.$store.commit('setSelected' + this.context + 'Product', this.selectedProduct.alvId)
        }
        if(this.selectedSearchMode === 1){
          this.$store.commit('setSelected' + this.context + 'Product', this.selectedProduct)
        }
        if(this.selectedSearchMode === 2){
          // Label search - selectedProduct is already an array of release IDs from the action
          this.$store.commit('setSelected' + this.context + 'Product', this.selectedProduct)
        }
        this.$emit("input", this.selectedProduct);
        this.close();
      },
      close() {
        this.isOpen = false;
      },
      updateSearchType(item){
        if(item == 1){
          this.$store.commit('setLabelStatisticsTrackOptions', [])
          this.$store.commit('setLabelStatisticsDetailsTrack', null)
        }

        if(item == 0){
          this.$store.commit('setLabelStatisticsReleaseOptions', [])
          this.$store.commit('setLabelStatisticsDetailsRelease', null)
        }
        this.$store.commit('setSelectedLabelStatisticsSearchType', item)
        this.$store.commit('setLabelStatisticsTagsSearchMessage', null)
      },
      updateSearchMode(){
        if(this.$store.getters.getSelectedLabelStatisticsSearchMode == 0){
          this.$store.commit('setLabelStatisticsDetailsProduct', null)
          this.$store.commit('setSelectedLabelStatisticsProduct', [])
          this.$store.commit('setLabelStatisticsDetailsTags', null)
          this.$store.commit('setLabelStatisticsSelectedLabel', null)
          this.$store.commit('setLabelStatisticsLabelSearchMessage', null)
        }

        if(this.$store.getters.getSelectedLabelStatisticsSearchMode == 1){
          this.$store.commit('setLabelStatisticsDetailsProduct', null)
          this.$store.commit('setSelectedLabelStatisticsProduct', [])
          this.$store.commit('setLabelStatisticsSelectedLabel', null)
          this.$store.commit('setLabelStatisticsLabelSearchMessage', null)
        }

        if(this.$store.getters.getSelectedLabelStatisticsSearchMode == 2){
          this.$store.commit('setLabelStatisticsDetailsProduct', null)
          this.$store.commit('setSelectedLabelStatisticsProduct', [])
          this.$store.commit('setLabelStatisticsDetailsTags', null)
          this.$store.commit('setLabelStatisticsTagsSearchMessage', null)
          // Fetch label dropdown options when entering label search mode
          this.$store.dispatch('fetchLabelStatisticsLabelDropdownOptions')
        }
      },
      getProductsByTags(){
        let domain = this.selectedSearchType == 0 ? 'tracks' : 'releases';
        let tags = this.selectedTags

        if(domain == 'releases'){
          this.$store.dispatch('fetchLabelStatisticsReleasesByTags', {
            tags: tags
          })
        }

        if(domain == 'tracks'){
            this.$store.dispatch('fetchLabelStatisticsTracksByTags', {
              tags: tags
            })
        }

      },
      getProductsByLabel(){
        if(this.selectedLabel){
          this.$store.dispatch('fetchLabelStatisticsReleasesByLabel', {
            labelId: this.selectedLabel
          })
        } else {
          // Label was cleared
          this.$store.commit('setLabelStatisticsDetailsProduct', null)
          this.$store.commit('setSelectedLabelStatisticsProduct', [])
          this.$store.commit('setLabelStatisticsLabelSearchMessage', null)
        }
      },
      resetSearchByTags(){
        this.$store.commit('setLabelStatisticsDetailsProduct', null)
        this.$store.commit('setSelectedLabelStatisticsProduct', [])
        this.$store.commit('setLabelStatisticsTagsSearchMessage', null)
      }
    },
  };
  </script>
  <style scoped>
  </style>